define((require) => {
    "use strict";

    const Effect = require("shared/ui/experience/widgets/effects/Effect");

    return Effect.extend({

        config() {
            return {
                scale: this.model.get("scale"),
                transformOrigin: "50% 50%"
            };
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/effects/ScaleEffect.js